export default __webpack_public_path__ + "static/media/Nesha_Laser_0011_Laser_4.d8f4b1be.png";